module.exports = "/cyber/_next/static/images/genshinTooltipMobile-50adcf7bc6c5858adb996f6371056af0.jpg";